/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ActionCompletionCheckbox_action$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Body_action$ref: FragmentReference;
declare export opaque type Body_action$fragmentType: Body_action$ref;
export type Body_action = {|
  +id: string,
  +isUpdating: ?boolean,
  +completedAt: ?any,
  +description: string,
  +rawDescription: string,
  +$fragmentRefs: ActionCompletionCheckbox_action$ref,
  +$refType: Body_action$ref,
|};
export type Body_action$data = Body_action;
export type Body_action$key = {
  +$data?: Body_action$data,
  +$fragmentRefs: Body_action$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Body_action",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "HTML"
        }
      ],
      "kind": "ScalarField",
      "name": "description",
      "storageKey": "description(format:\"HTML\")"
    },
    {
      "alias": "rawDescription",
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "PLAIN"
        }
      ],
      "kind": "ScalarField",
      "name": "description",
      "storageKey": "description(format:\"PLAIN\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActionCompletionCheckbox_action"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUpdating",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Action",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'dfb7d22839eeef695296ad3ade9ec4fa';

module.exports = node;
